import React from 'react';
import styled from 'styled-components';
import Popover from '@material-ui/core/Popover';
import Fade from '@material-ui/core/Fade';

import { CategoryLink } from 'shop/hooks/categories/use-category-links';
import { StyledTheme } from 'src/theme/styled-theme-type';

import { ShopButton } from './shop-button';
import { ShopMenu } from './shop-menu';

type ShopDropdownProps = {
  anchorEl?: HTMLElement;
  categories: CategoryLink[];
  open: boolean;
  toggleShopMenu: () => void;
};

const popoverProps = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  TransitionComponent: Fade,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
};

export function ShopDropdown({ anchorEl, categories, open, toggleShopMenu }: ShopDropdownProps): JSX.Element {
  return (
    <>
      <ShopButton onClick={toggleShopMenu} />
      <StyledPopover open={open} anchorEl={anchorEl} backdropInvisible {...popoverProps} onClose={toggleShopMenu}>
        <ShopMenu categories={categories} />
      </StyledPopover>
    </>
  );
}

const StyledPopover = styled(Popover)`
  .MuiPaper-root {
    border-radius: 0 0 14px 14px;
    box-shadow: ${({ theme }: { theme: StyledTheme }) => `0px 3px 18px ${theme.colors.basicShadow}`};
  }
  .MuiPopover-paper {
    left: 0 !important;
    min-width: 100vw;
    margin-top: 13px;
  }

  &.MuiPopover-root {
    /* global-header z-index - 100 so that the backdrop doesn't cover it */
    z-index: 1100 !important;
  }
`;
